import { render, staticRenderFns } from "./RenameDatabaseModal.vue?vue&type=template&id=5b237628&"
import script from "./RenameDatabaseModal.vue?vue&type=script&lang=js&"
export * from "./RenameDatabaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b237628')) {
      api.createRecord('5b237628', component.options)
    } else {
      api.reload('5b237628', component.options)
    }
    module.hot.accept("./RenameDatabaseModal.vue?vue&type=template&id=5b237628&", function () {
      api.rerender('5b237628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Mysql/Databases/RenameDatabaseModal.vue"
export default component.exports